import { instanceAdminApi } from '@/api/instance';

export const sendTrackingData = (trackingPayload: string): void => {
  instanceAdminApi.post('tracker/receive', trackingPayload);
};
